import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { FormControl } from '@angular/forms';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { Module } from 'app/library/module/models/module.model';
import { FetchMyPublishedModulesSuccess } from 'app/library/my-published-modules/actions';
import { FetchMyUnpublishedModules } from 'app/library/my-unpublished-modules/actions';
import { TagMultiSelectService } from 'app/library/tag/services/multi-select.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';

export class UnpublishedModuleDataSource implements DataSource<Module> {
    statusCtrl = new FormControl({ value: '', disabled: false });

    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    constructor(private _filteredModule$: Observable<Module[]>, private _store: Store, private _action$: Actions, public tagMultiSelectService: TagMultiSelectService) {}

    connect(collectionViewer: CollectionViewer): Observable<Module[]> {
        return this._filteredModule$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadModules(category: string, search?: string, sortBy?: string, sortOrder?: string, pageSize?: number, pageNumber?: number, participantId?: string, tag?: number[]): void {
        this._loadingSubject.next(true);
        this._store.dispatch(
            new FetchMyUnpublishedModules({
                category,
                search,
                sortBy,
                sortOrder,
                pageSize,
                pageNumber: pageNumber,
                participantId,
                tag,
            })
        );
        this._action$
            .pipe(
                ofActionDispatched(FetchMyPublishedModulesSuccess),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
